jQuery(document).ready(function ($) {
  const root = $('[data-hcm-voting-gallery]');
  if (!root.length || typeof hcmVoting === 'undefined') {
    return;
  }

  root.each(function () {
    const gallery = $(this);
    const galleryId = parseInt(gallery.data('galleryId'), 10);
    const formId = parseInt(gallery.data('formId'), 10);
    let voted =
      gallery.data('userHasVoted') === 1 || gallery.data('userHasVoted') === '1';

    function applyCounts(counts) {
      if (!counts || typeof counts !== 'object') {
        return;
      }
      gallery.find('[data-entry-id]').each(function () {
        const el = $(this);
        const id = parseInt(el.data('entryId'), 10);
        const n =
          Object.prototype.hasOwnProperty.call(counts, id)
            ? counts[id]
            : counts[String(id)];
        if (n !== undefined && n !== null) {
          el.find('.hcm-voting__count').text(n);
        }
      });
    }

    gallery.on('click', '.hcm-voting__btn:not(:disabled)', function () {
      const btn = $(this);
      const card = btn.closest('[data-entry-id]');
      const entryId = parseInt(card.data('entryId'), 10);
      if (voted || !entryId) {
        return;
      }

      btn.prop('disabled', true);
      gallery.find('.hcm-voting__btn').prop('disabled', true);

      $.ajax({
        url: hcmVoting.ajaxUrl,
        type: 'POST',
        dataType: 'json',
        data: {
          action: 'hcm_cast_vote',
          nonce: hcmVoting.nonce,
          gallery_id: galleryId,
          form_id: formId,
          entry_id: entryId,
        },
      })
        .done(function (res) {
          gallery.find('.hcm-voting__global-msg').remove();
          if (res && res.success && res.data && res.data.vote_counts) {
            voted = true;
            applyCounts(res.data.vote_counts);
            const msg = res.data.message || '';
            if (msg) {
              gallery.prepend(
                $('<p class="alert alert-success hcm-voting__global-msg" role="status"/>').text(msg)
              );
            }
            gallery.find('.hcm-voting__btn').prop('disabled', true);
          } else {
            const err =
              (res && res.data && res.data.message) || 'Abstimmung fehlgeschlagen.';
            gallery.prepend(
              $('<p class="alert alert-danger hcm-voting__global-msg" role="alert"/>').text(err)
            );
            gallery.find('.hcm-voting__btn').prop('disabled', false);
          }
        })
        .fail(function (xhr) {
          gallery.find('.hcm-voting__global-msg').remove();
          let err = 'Abstimmung fehlgeschlagen.';
          if (xhr.responseJSON && xhr.responseJSON.data && xhr.responseJSON.data.message) {
            err = xhr.responseJSON.data.message;
          }
          gallery.prepend(
            $('<p class="alert alert-danger hcm-voting__global-msg" role="alert"/>').text(err)
          );
          gallery.find('.hcm-voting__btn').prop('disabled', false);
        });
    });
  });
});



// WEBPACK FOOTER //
// ./scripts/autoload/voting-gallery.js